<template>
    <div class="row" :style="rowStyle">
        <div class="form-inline col-md-2">
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon color="grey lighten-1" class="tooltip-small">
                            mdi-information-outline
                        </v-icon>
                    </v-btn>
                </template>
                <span>Choose a date period for the custom audience. <br> The earliest date available is 48 hours ago.</span>
            </v-tooltip>

            <i class="far fa-calendar-alt"></i> <span style="padding-left: 5px;"> Recency</span>
        </div>
        <div class="form-group col-md-7">
            <div class="input-daterange form-inline datesSelection" >
                <v-menu
                    v-model="start_date_menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="start_date"
                            label="Start Date"
                            clearable
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :rules="[requiredStartDate]"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        header-color="#fb7e42"
                        color="#fb7e42"
                        v-model="start_date"
                        @input="start_date_menu = false"
                        :max="$store.getters['CreateAudienceStore/getRecencyEnd'](dataSetOrder) || date_limit"
                        :min="min_date_limit || deep_archive_limit_date"
                    ></v-date-picker>
                </v-menu>
                <span class="mx-2">to</span>
                <v-menu
                    v-model="end_date_menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="end_date"
                            label="End Date"
                            clearable
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :rules="[requiredEndDate]"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        header-color="#fb7e42"
                        color="#fb7e42"
                        v-model="end_date"
                        @input="end_date_menu = false"
                        :min="$store.getters['CreateAudienceStore/getRecencyStart'](dataSetOrder) || min_date_limit || deep_archive_limit_date"
                        :max="date_limit"
                    ></v-date-picker>
                </v-menu>
            </div>
            <div class="recency-options">
                <span v-for="option in recency_options"
                      v-if="option.support_analyses.includes($store.getters['CreateAudienceStore/getAnalysisType'](dataSetOrder))"
                      class="mr-2"
                      @click="setRecency(option.slug)"
                >
                    {{ option.label }}
                </span>
            </div>
        </div><!--form-group-->
    </div>
</template>

<script>
import analyses from "../../../../mixin/analyses";

export default {
    name: "Recency",
    mixins: [analyses],
    props: [
        'dataSetOrder',
        'rowStyle',
        'analysisType'
    ],
    data: () => ({
        recency_options: [],
        utc_now: '',
        today: '',
        date_limit: '',
        min_date_limit: '',

        start_date_menu: false,
        end_date_menu: false,

        requiredStartDate: v => v && v.length > 0 || 'Start Date field is required',
        requiredEndDate: v => v && v.length > 0 || 'End Date field is required',
    }),
    created() {
        this.setRecencyOptions()
    },
    methods: {
        setRecency(requested_period) {
            let limit = new Date(this.date_limit)

            let start = ''
            let end = ''

            if (requested_period === 'last-week') {
                start = new Date(limit.getTime() - (7 * 24 * 60 * 60 * 1000)) // 7 days * 24 hours * 60 minutes * 60 seconds * 1000 milliseconds
                end = limit
            }

            if (requested_period === 'last-month') {
                start = new Date(this.utc_now)
                start.setDate(1)
                start.setMonth(start.getMonth() - 1)

                end = new Date(this.utc_now)
                end.setDate(0)
            }

            if (requested_period === 'last-three-months') {
                start = new Date(this.utc_now)
                start.setDate(1)
                start.setMonth(start.getMonth() - 3)

                end = new Date(this.utc_now)
                end.setDate(0)
            }

            if (requested_period === 'year-to-date') {
                start = new Date(this.utc_now)
                start.setDate(1)
                start.setMonth(0)

                end = this.today
            }

            if (requested_period === 'month-to-date') {
                start = new Date(this.utc_now)
                start.setDate(1)

                end = this.today
            }

            if (end > limit) {
                end = limit
            }

            if (start > end) {
                start = end
            }

            if (start < new Date(this.min_date_limit)) {
                start = new Date(this.min_date_limit)
            }

            this.$store.commit('CreateAudienceStore/SET_RECENCY_START', {
                dataset: this.dataSetOrder,
                value: start.toJSON().slice(0, 10)
            })
            this.$store.commit('CreateAudienceStore/SET_RECENCY_END', {
                dataset: this.dataSetOrder,
                value: end.toJSON().slice(0, 10)
            })
        },
        updateDateLimits() {
            // Set the Data Delay Limit
            let date = new Date(new Date().getTime() - (48 * 60 * 60 * 1000)) // 48 hours * 60 minutes * 60 seconds * 1000 milliseconds
            this.date_limit = date.toJSON().slice(0, 10)

            // Convert the dates selection to UTC
            let now = new Date();
            this.utc_now =  Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(),
                now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds());
            this.today = new Date(this.utc_now);

            // Set min_date_limit as per the POI type
            if (this.$store.getters['CreateAudienceStore/getAnalysisType'](this.dataSetOrder) === 'Anonymized' && !this.$store.getters.getUserPermissions.includes('feature-activation-analyses-anonymized-period-no-limit')) {
                let min_date = new Date()
                min_date.setMonth(min_date.getMonth() - 1);
                min_date.setDate(1);
                this.min_date_limit = min_date.toJSON().slice(0, 10)

            } else if (this.$store.getters['CreateAudienceStore/getAnalysisType'](this.dataSetOrder) === 'Anonymized' && this.$store.getters.getUserPermissions.includes('feature-activation-analyses-anonymized-period-no-limit')) {
                this.min_date_limit = this.deep_archive_limit_date

            } else if (this.$store.getters['CreateAudienceStore/getAnalysisType'](this.dataSetOrder) === 'POI') {
                this.min_date_limit = this.poi_deep_archive_limit_date

            } else {
                this.min_date_limit = ''

            }
        },
        setRecencyOptions() {
            this.recency_options = [
                {
                    "slug": "last-week",
                    "label": "Last Week",
                    "support_analyses": [
                        this.analyses.types.apps,
                        this.analyses.types.poi,
                        this.analyses.types.cohorts,
                        this.analyses.types.anonymized,
                        this.analyses.types.competitors,
                        this.analyses.additional.cross_visitation
                    ]
                },
                {
                    "slug": "month-to-date",
                    "label": "MTD (Month To Date)",
                    "support_analyses": [
                        this.analyses.types.apps,
                        this.analyses.types.poi,
                        this.analyses.types.cohorts,
                        this.analyses.types.anonymized,
                        this.analyses.types.competitors,
                        this.analyses.additional.cross_visitation
                    ]
                },
                {
                    "slug": "last-month",
                    "label": "Last Full Month",
                    "support_analyses": [
                        this.analyses.types.apps,
                        this.analyses.types.poi,
                        this.analyses.types.cohorts,
                        this.analyses.types.anonymized,
                        this.analyses.types.competitors,
                        this.analyses.additional.cross_visitation
                    ]
                },
                {
                    "slug": "last-three-months",
                    "label": "Last 3 Full Months",
                    "support_analyses": [
                        this.analyses.types.apps,
                        this.analyses.types.poi,
                        this.analyses.types.cohorts,
                        this.analyses.types.competitors,
                        this.analyses.additional.cross_visitation
                    ]
                },
                {
                    "slug": "year-to-date",
                    "label": "YTD (Year To Date)",
                    "support_analyses": [
                        this.analyses.types.apps,
                        this.analyses.types.poi,
                        this.analyses.types.cohorts,
                        this.analyses.types.competitors,
                        this.analyses.additional.cross_visitation
                    ]
                }
            ]
        },
    },
    computed: {
        start_date: {
            get() {
                return this.$store.getters['CreateAudienceStore/getRecencyStart'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_RECENCY_START', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        end_date: {
            get() {
                return this.$store.getters['CreateAudienceStore/getRecencyEnd'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_RECENCY_END', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        }
    },
    mounted() {
        this.updateDateLimits()
    },
    watch: {
        analysisType: function () {
            this.updateDateLimits()
        }
    }
}
</script>

<style scoped>

</style>